import './list_info_component.scss'

import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = []

  DEFAULT_POSITION = 0
  STICKY_TOP_POSITION = 1
  STICKY_BOTTOM_POSITION = 2

  connect () {
    this.refreshSizeAndPosition()
  }

  refreshSizeAndPosition () {
    const tempPosition = this.position
    this.resetPosition()

    this.element.style.width = ''
    this.offsetLeft = this.element.offsetLeft
    this.width = this.element.offsetWidth
    this.height = this.element.offsetHeight
    this.element.style.width = `${this.width}px`
    this.element.style.left = `${this.offsetLeft}px`

    if (tempPosition === this.STICKY_TOP_POSITION) {
      this.stickToTop()
    } else if (tempPosition === this.STICKY_BOTTOM_POSITION) {
      this.stickToBottom()
    }
  }

  stickToTop () {
    this.resetPosition()
    this.element.style.position = 'fixed'
    this.position = this.STICKY_TOP_POSITION
    this.element.style.top = '80px'
  }

  stickToBottom () {
    this.resetPosition()
    this.element.style.position = 'absolute'
    this.element.style.bottom = `${this.listBottomMargin}px`
    this.position = this.STICKY_BOTTOM_POSITION
  }

  resetPosition () {
    this.element.style.position = 'initial'
    this.element.style.top = 'initial'
    this.element.style.bottom = 'initial'
    this.position = this.DEFAULT_POSITION
  }

  get listController () {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === 'list'
    })
  }

  get productListController () {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === 'product-list'
    })
  }

  get listBottomMargin () {
    return this.listController.BOTTOM_MARGIN
  }
}
